//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  faArrowCircleDown,
  faComputerClassic,
  faArrowDown,
} from '@fortawesome/pro-light-svg-icons';

export default {
  name: 'LottieGettingStarted',
  components: {
    HomeBenefits: () => import('@/components/home-page/HomeBenefits.vue'),
    StepItem: () => import('@/components/core/elements/StepItem.vue'),
  },
  data() {
    return {
      faArrowCircleDown,
      faComputerClassic,
      faArrowDown,
    };
  },
};
